import { CID_COOKIE } from 'config/cookie';
import { cookiesInstance } from './cookiesInstance';

export const set = (value: string) => cookiesInstance.set(CID_COOKIE, value);

export const get = () => {
  const cid = cookiesInstance.get(CID_COOKIE);
  return cid ?? '';
};

export const remove = () => cookiesInstance.remove(CID_COOKIE);
